export default {
  form: {
    title: "Xplora Login ",
    username: "Telefonnummer der Eltern",
    password: "Gib den Code ein, den wir dir per SMS gesendet haben.",
    language: "Sprache",
    submit: "Login",
    continue: "Weiter",
    usernameValidationMessage: "Die Telefonnummer der Eltern eingeben.",
    otpHint: "",
    phoneNumberInputInstructions:
      "Bitte geben Sie Ihre Telefonnummer ohne die Landesvorwahl (+46) oder die führende Null ein.\nBeispiel: 701234567\nBitte nicht eingeben: 0701234567, 46701234567 oder 460701234567",
  },
  logoutDialog: {
    title: "Eingeloggt als",
  },
  loginInfo: {
    title: "Bis du ein Xplora-Abonnent?",
    content: `HINWEIS: Wenn das Abonnement für eine Xplora Uhr gilt, gib die Handynummer der Eltern ein, nicht die der Smartwatch. \n \n Bitte beachte, dass es nach der Auftrag bis zu 30 Minuten dauern kann, bis du dich einloggen kannst.`,
  },
} as const;
